const app_env = import.meta.env.VITE_APP_ENV === 'production' ? 'production' : 'staging';

export async function fetchEnvs() {
    try {
        const response = await fetch(route("main.getWalletConfigs"), {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
        }).then((response) => response.json());
        return JSON.parse(response);
    } catch (error) {
        console.error("Error fetching environment variables:", error);
        return {
            env: '',
            project_id: '',
            oracle_module: '',
            oracle_fee: '',
            current_chain: '',
            rpc_url: '',
            expiration_buffer: null,
            gas_limit: null,
            beneficiary: null,
            metadata: {
                name: '0xpledges',
                description: '0xpledges is a decentralized platform for creating and fulfilling pledges.',
                url: app_env === 'production' ? 'https://0xpledges.com' : 'https://dev.0xpledges.com',
                icons: ['https://0xpledges.com/images/portex_logo_no_bg.png'],
            }
        };
    }
}

export const ENV = await fetchEnvs();

const requiredEnvKeys = ["env", "project_id", "oracle_module"];

function validateEnv(
    env: {
        [x: string]: unknown;
        env?: string;
        project_id?: string;
        oracle_module?: string;
        oracle_fee?: string;
        current_chain?: string;
    },
    requiredKeys: string[],
    defaults = {}
) {
    const missingKeys = requiredKeys.filter((key) => !env[key]);

    for (const [key, value] of Object.entries(defaults)) {
        if (!env[key]) {
            env[key] = value;
        }
    }

    if (missingKeys.length > 0) {
        throw new Error(
            `Missing required environment variables: ${missingKeys.join(", ")}`
        );
    }
}

try {
    validateEnv(ENV, requiredEnvKeys);
} catch (error) {
    if (error instanceof Error) {
        console.error(`Environment validation failed: ${error.message}`);
    } else {
        console.error("Environment validation failed: Unknown error");
    }
}
